<template>
    <div>
        <div v-if="isOutlook">
            <div class="form-group" :class="{'has-error': errors.has('comment')}">
                <label for="comment" class="col-sm-2 control-label">Description of Services:</label>
                <div class="col-sm-10 col-md-8 col-lg-6">
                    <input v-validate.disable="'required'" data-vv-as="Re" type="text" class="form-control"
                           id="comment" name="comment" v-model="timeEntry.comment"
                           placeholder="Summary (100 characters max)" maxlength="100"
                           @keyup="commentCheck" autocomplete="on" />
                    <p class="text-danger" v-if="errors.has('comment')">{{ errors.first('comment') }}</p>
                </div>
            </div>
            <div class="form-group">
                <label for="noteText" class="col-sm-2 control-label">Content:</label>
                <div class="col-sm-10 col-md-8">
                    <textarea class="form-control" rows="3" id="noteText" name="noteText" :readonly="isOutlook"
                              v-model="timeEntry.noteText" placeholder="What happened? (detailed)"></textarea>
                    <p class="text-danger" v-if="errors.has('noteText')">{{ errors.first('noteText') }}</p>
                </div>
            </div>
        </div>
        <div v-else class="form-group" :class="{'has-error': errors.has('noteText')}">
            <div class="col-sm-2 control-label">
                <label for="noteText">Description of Services:</label>
                <div><small class="text-muted">First 400 characters</br>appear on invoice</small></div>
            </div>
            <div class="col-sm-10 col-md-8">
                <textarea class="form-control" rows="4" id="noteText" name="noteText"
                          v-model="timeEntry.noteText"
                          placeholder="Summary followed by detailed comment"></textarea>
                <p class="text-danger" v-if="errors.has('noteText')">{{ errors.first('noteText') }}</p>
                <small v-show="timeEntry.isLegacyTEEntry" class="text-warning">RE/Comment have been combined. Review and ensure the Description of Services appears as intended.</small>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";

    export default {
        inject: ['$validator'],
        data: function () {
            return {
                timeEntry: this.$store.state.timeEntry
            };
        },
        props: {
            isOutlook: Boolean
        },
        methods: {
            commentCheck() {
                // This method was copied from the old KEA.  When the "Re:" fields runs out of characters
                // it moves focus into the "Comment" field and moves the word that is currently being typed
                // into the Comment field.  

                let sElementText = this.timeEntry.comment;
                let maxLength = 100;

                if ((sElementText.length > maxLength - 1) && (this.timeEntry.noteText.length == 0)) {

                    // Find last word being typed..
                    var iLastSpace = sElementText.lastIndexOf(' ')
                    // Move the last word from thisEl to nextEl
                    if ((iLastSpace < sElementText.length) && (iLastSpace > 0)) {
                        this.timeEntry.noteText = sElementText.substr(iLastSpace + 1)
                        this.timeEntry.comment = sElementText.substr(0, iLastSpace)
                    }
                    // focus on next text box
                    var textArea = document.getElementById("noteText");
                    textArea.focus();

                    // Move cursor to end of text box
                    var r = textArea.createTextRange();
                    r.moveStart('character', textArea.value.length);
                    r.collapse();
                    r.select();
                }
            }
        }
    };
</script>